<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Loading Spinner -->
  @if (formState.isLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- Form Content -->
  @if (!formState.isLoading) {
<div class="panel panel-default">
    <div class="panel-body">
      <div>
        <!-- Category Level Section -->
        <div class="row mb-30">
          <div class="col-md-12">
            <label class="heading">Category Level</label>
            <hr />
          </div>

          <!-- Level Dropdown -->
          <div class="form-group col-xs-2 col-md-2">
            <label for="level" class="control-label">Level</label>
            <select id="level"
                    class="form-control"
                    [(ngModel)]="formState.level"
                    (ngModelChange)="onLevelChange()"
                    [disabled]="formState.levelDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (option of levelDetails; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>

          <!-- Level Entity Dropdown (Filing Group / Parent ME / ME) -->
          @if (formState.level?.CODE_DESCRIPTION) {
<div class="form-group col-xs-2 col-md-3"
              >
            <label for="levelEntity" class="control-label">{{ getLevelEntityLabel() }}</label>

            <!-- Filing Group -->
            @if (formState.level?.CODE_DESCRIPTION === 'Filing Group') {
<select
                    id="filingGroup"
                    class="form-control"
                    [(ngModel)]="formState.filingGroup"
                    (ngModelChange)="onLevelEntityChange()"
                    [disabled]="formState.levelEntityDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (option of filingDetails; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.PARENT_ME_NAME }}
              </option>
}
            </select>
}

            <!-- Parent ME -->
            @if (formState.level?.CODE_DESCRIPTION === 'Parent ME') {
<select
                    id="parentME"
                    class="form-control"
                    [(ngModel)]="formState.parentME"
                    (ngModelChange)="onLevelEntityChange()"
                    [disabled]="formState.levelEntityDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (option of parentDetails; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.PARENT_ME_NAME }}
              </option>
}
            </select>
}

            <!-- ME -->
            @if (formState.level?.CODE_DESCRIPTION === 'ME') {
<select
                    id="meInfo"
                    class="form-control"
                    [(ngModel)]="formState.meInfo"
                    (ngModelChange)="onLevelEntityChange()"
                    [disabled]="formState.levelEntityDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (option of meDetails; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.PARENT_ME_NAME }}
              </option>
}
            </select>
}
          </div>
}

          <!-- Gross Inc/Exp -->
          @if (formState.level1Show) {
<div class="form-group col-xs-2"
              >
            <label for="grossIncome" class="control-label">Gross Inc/Exp</label>
            <select id="grossIncome"
                    class="form-control"
                    [(ngModel)]="formState.grossIncome"
                    (ngModelChange)="onGrossIncomeChange()"
                    [disabled]="formState.grossIncomeDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (option of grossIncomeDetails; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.DISP_ACCT_CODE }}
              </option>
}
            </select>
          </div>
}

          <!-- Trans Category -->
          @if (formState.level1Show) {
<div class="form-group col-xs-3 col-md-3"
              >
            <label for="transCategory" class="control-label">Trans Category</label>
            <input id="transCategory"
                   class="form-control go-to-input"
                   type="text"
                   [(ngModel)]="formState.transactionCategory"
                   maxlength="200" />
            <div class="max_length">Max Length 200</div>
          </div>
}

          <!-- Map -->
          @if (formState.level1Show) {
<div class="form-group col-xs-2 col-md-2"
              >
            <label for="mapTo" class="control-label">Map</label>
            <select id="mapTo"
                    class="form-control"
                    [(ngModel)]="formState.mapTo"
                    (ngModelChange)="onMapChange()"
                    [disabled]="formState.mapDisabled || formState.isINC">
              <option [ngValue]="null">-- Select --</option>
              @for (option of mapDetails; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
}

        </div>

        <!-- Second Row: Method Desc and Base Fields -->
        @if (formState.showMethodDesc || formState.showBaseFdii || formState.showBaseFdiiSingle) {
<div class="row">
          <!-- Method Desc -->
          @if (formState.showMethodDesc) {
<div class="form-group col-xs-2 col-md-2"
              >
            <label for="methodKey" class="control-label">Method Desc</label>
            <select id="methodKey"
                    class="form-control"
                    [(ngModel)]="formState.methodKey"
                    (ngModelChange)="onMethodChange()"
                    [disabled]="formState.methodDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (option of methodKeys; track trackByFn($index, option)) {
<option
                      [ngValue]="option">
                {{ option.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
}

          <!-- Base FDII (Multi-select) - Custom Searchable Multiselect -->
          @if (formState.showBaseFdii) {
<div class="form-group col-xs-2 col-md-2"
              >
            <label>Base FDII</label>
            <div class="custom-searchable-multiselect" 
                 data-dropdown="baseFdii"
                 [class.open]="baseFdiiDropdownOpen">
              <div class="dropdown-input-wrapper" 
                   (click)="toggleBaseFdiiDropdown()">
                <input type="text" 
                       class="form-control dropdown-input" 
                       [value]="getSelectedBaseFdiiDisplay()"
                       readonly
                       placeholder="Select Base FDII" />
                <span class="dropdown-arrow">
                  <i class="fa" [class.fa-caret-down]="!baseFdiiDropdownOpen" [class.fa-caret-up]="baseFdiiDropdownOpen"></i>
                </span>
              </div>
              @if (baseFdiiDropdownOpen) {
<div class="dropdown-menu-container" 
                  
                   (click)="$event.stopPropagation()">
                <div class="dropdown-search">
                  <input type="text" 
                         class="form-control search-input" 
                         [(ngModel)]="baseFdiiSearchText"
                         placeholder="Search..."
                         (click)="$event.stopPropagation()" />
                </div>
                <div class="dropdown-actions">
                  <button type="button" class="btn btn-xs btn-link" (click)="selectAllBaseFdii($event); $event.stopPropagation()">Select All</button>
                  <button type="button" class="btn btn-xs btn-link" (click)="unselectAllBaseFdii($event); $event.stopPropagation()">Unselect All</button>
                </div>
                <ul class="dropdown-options">
                  @for (option of getFilteredBaseFdiiOptions(); track $index) {
<li
                      (click)="toggleBaseFdiiSelection(option, $event); $event.stopPropagation()"
                      [class.selected]="isBaseFdiiSelected(option)">
                    <input type="checkbox" 
                           [checked]="isBaseFdiiSelected(option)"
                           (change)="toggleBaseFdiiSelection(option, $event)"
                           (click)="$event.stopPropagation()" />
                    <span>{{ option.CODE_DESCRIPTION }}</span>
                  </li>
}
                </ul>
              </div>
}
            </div>
          </div>
}

          <!-- Base Basket (Multi-select) - Custom Searchable Multiselect -->
          @if (formState.showBaseBasket) {
<div class="form-group col-xs-2 col-md-2"
              >
            <label>Base Basket</label>
            <div class="custom-searchable-multiselect" 
                 data-dropdown="baseBasket"
                 [class.open]="baseBasketDropdownOpen">
              <div class="dropdown-input-wrapper" 
                   (click)="toggleBaseBasketDropdown()">
                <input type="text" 
                       class="form-control dropdown-input" 
                       [value]="getSelectedBaseBasketDisplay()"
                       readonly
                       placeholder="Select Base Basket" />
                <span class="dropdown-arrow">
                  <i class="fa" [class.fa-caret-down]="!baseBasketDropdownOpen" [class.fa-caret-up]="baseBasketDropdownOpen"></i>
                </span>
              </div>
              @if (baseBasketDropdownOpen) {
<div class="dropdown-menu-container" 
                  
                   (click)="$event.stopPropagation()">
                <div class="dropdown-search">
                  <input type="text" 
                         class="form-control search-input" 
                         [(ngModel)]="baseBasketSearchText"
                         placeholder="Search..."
                         (click)="$event.stopPropagation()" />
                </div>
                <div class="dropdown-actions">
                  <button type="button" class="btn btn-xs btn-link" (click)="selectAllBaseBasket($event); $event.stopPropagation()">Select All</button>
                  <button type="button" class="btn btn-xs btn-link" (click)="unselectAllBaseBasket($event); $event.stopPropagation()">Unselect All</button>
                </div>
                <ul class="dropdown-options">
                  @for (option of getFilteredBaseBasketOptions(); track $index) {
<li
                      (click)="toggleBaseBasketSelection(option, $event); $event.stopPropagation()"
                      [class.selected]="isBaseBasketSelected(option)">
                    <input type="checkbox" 
                           [checked]="isBaseBasketSelected(option)"
                           (change)="toggleBaseBasketSelection(option, $event)"
                           (click)="$event.stopPropagation()" />
                    <span>{{ option.CODE_DESCRIPTION }}</span>
                  </li>
}
                </ul>
              </div>
}
            </div>
          </div>
}

          <!-- Base Type (Multi-select) - Custom Searchable Multiselect -->
          @if (formState.showBaseType) {
<div class="form-group col-xs-2 col-md-2"
              >
            <label>Base Type</label>
            <div class="custom-searchable-multiselect" 
                 data-dropdown="baseType"
                 [class.open]="baseTypeDropdownOpen"
                 [class.disabled]="isBaseLevelAllME()">
              <div class="dropdown-input-wrapper" 
                   (click)="!isBaseLevelAllME() && toggleBaseTypeDropdown()">
                <input type="text" 
                       class="form-control dropdown-input" 
                       [value]="getSelectedBaseTypeDisplay()"
                       readonly
                       [disabled]="isBaseLevelAllME()"
                       placeholder="Select Base Type" />
                <span class="dropdown-arrow">
                  <i class="fa" [class.fa-caret-down]="!baseTypeDropdownOpen" [class.fa-caret-up]="baseTypeDropdownOpen"></i>
                </span>
              </div>
              @if (baseTypeDropdownOpen && !isBaseLevelAllME()) {
<div class="dropdown-menu-container" 
                  
                   (click)="$event.stopPropagation()">
                <div class="dropdown-search">
                  <input type="text" 
                         class="form-control search-input" 
                         [(ngModel)]="baseTypeSearchText"
                         placeholder="Search..."
                         (click)="$event.stopPropagation()" />
                </div>
                <div class="dropdown-actions">
                  <button type="button" class="btn btn-xs btn-link" (click)="selectAllBaseType($event); $event.stopPropagation()">Select All</button>
                  <button type="button" class="btn btn-xs btn-link" (click)="unselectAllBaseType($event); $event.stopPropagation()">Unselect All</button>
                </div>
                <ul class="dropdown-options">
                  @for (option of getFilteredBaseTypeOptions(); track $index) {
<li
                      (click)="toggleBaseTypeSelection(option, $event); $event.stopPropagation()"
                      [class.selected]="isBaseTypeSelected(option)">
                    <input type="checkbox" 
                           [checked]="isBaseTypeSelected(option)"
                           (change)="toggleBaseTypeSelection(option, $event)"
                           (click)="$event.stopPropagation()" />
                    <span>{{ formState.methodKey?.CODE_DESCRIPTION === 'Gross Income' ? option.CODE_UPDATED_DESCRIPTION : option.CODE_DESCRIPTION }}</span>
                  </li>
}
                </ul>
              </div>
}
            </div>
          </div>
}

          <!-- Base FDII (Single-select for Allocate) -->
          @if (formState.showBaseFdiiSingle) {
<div class="form-group col-xs-2 col-md-2 single"
              >
            <label>Base FDII</label>
            <select id="baseFdiiSingle"
                    class="form-control"
                    [(ngModel)]="formState.selectedBaseFdiiCodes"
                    [disabled]="formState.baseFieldsDisabled">
              <option value="">-- Select --</option>
              @for (s of baseFDIIData; track trackByFn($index, s)) {
<option
                      [value]="s.CODE_KEY">
                {{ s.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
}

          <!-- Base Basket (Single-select for Allocate) -->
          @if (formState.showBaseBasketSingle) {
<div class="form-group col-xs-2 col-md-2 single"
              >
            <label>Base Basket</label>
            <select id="baseBasketSingle"
                    class="form-control"
                    [(ngModel)]="formState.selectedBaseBasketCode"
                    [disabled]="formState.baseFieldsDisabled">
              <option value="">-- Select --</option>
              @for (s of basketCodeAllocateData; track trackByFn($index, s)) {
<option
                      [value]="s.CODE_KEY">
                {{ s.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
}

          <!-- Base Level -->
          @if (formState.showBaseLevel) {
<div class="form-group col-xs-2 col-md-1"
              >
            <label>Base Level</label>
            <select id="baseLevel"
                    class="form-control"
                    [(ngModel)]="formState.selectedBaseLevelCode"
                    (ngModelChange)="onBaseLevelChange()"
                    [disabled]="formState.baseFieldsDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (s of baseLevelData; track trackByFn($index, s)) {
<option
                      [ngValue]="s.CODE_KEY">
                {{ s.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
}

          <!-- Base Entity Level -->
          @if (formState.showBaseEntityLevel) {
<div class="form-group col-xs-2 col-md-2"
              >
            <label>Base Entity Level</label>
            <select id="baseEntityLevel"
                    class="form-control"
                    [(ngModel)]="formState.selectedBaseEntityLevelCode"
                    [disabled]="formState.baseFieldsDisabled">
              <option [ngValue]="null">-- Select --</option>
              @for (s of baseEntityData; track trackByFn($index, s)) {
<option
                      [ngValue]="s.CODE_KEY">
                {{ s.CODE_DESCRIPTION }}
              </option>
}
            </select>
          </div>
}
        </div>
}

        <!-- Map Details Section -->
        @if (formState.level2Show) {
<div class="row mb-30">
          <div class="col-md-12">
            <label class="heading">Map Details</label>
            @if (formState.isLoadingMapDetails) {
<span class="map-details-loader">
              <i class="fa fa-spinner fa-spin"></i> Loading...
            </span>
}
            <hr />
          </div>

          <!-- System Account (by Account) - Custom Searchable Multiselect -->
          @if (formState.showSystemAccount) {

            <div class="form-group col-xs-3 col-md-3">
              <label for="systemAccount" class="control-label">System Account
                @if (isLoadingSystemAccounts) {
<span class="loader-spinner"></span>
}
              </label>
              <div class="custom-searchable-multiselect" 
                   data-dropdown="systemAccount"
                   [class.open]="systemAccountDropdownOpen">
                <div class="dropdown-input-wrapper" 
                     (click)="toggleSystemAccountDropdown()">
                  <input type="text" 
                         class="form-control dropdown-input" 
                         [value]="getSelectedSystemAccountsDisplay()"
                         readonly
                         placeholder="Select System Account">
                  <i class="fa dropdown-arrow" 
                     [ngClass]="{'fa-chevron-up': systemAccountDropdownOpen, 'fa-chevron-down': !systemAccountDropdownOpen}"></i>
                </div>
                @if (systemAccountDropdownOpen) {
<div class="dropdown-menu" 
                    
                     (click)="$event.stopPropagation()">
                  <div class="dropdown-search-wrapper">
                    <input type="text" 
                           class="form-control dropdown-search-input" 
                           [(ngModel)]="systemAccountSearchText"
                           placeholder="Search..."
                           (click)="$event.stopPropagation()">
                    <i class="fa fa-search dropdown-search-icon"></i>
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" class="btn btn-link btn-sm"
                            (click)="selectAllSystemAccounts(); $event.stopPropagation()">Select All</button>
                    <button type="button" class="btn btn-link btn-sm"
                            (click)="unselectAllSystemAccounts(); $event.stopPropagation()">Unselect All</button>
                  </div>
                  <div class="dropdown-items-wrapper">
                    @if (getFilteredSystemAccounts().length === 0) {
<div class="dropdown-no-results">No results found</div>
}
                    @for (option of getFilteredSystemAccounts(); track $index) {
<div 
                         class="dropdown-item checkbox-item"
                         (click)="toggleSystemAccountSelection(option); $event.stopPropagation()">
                      <input type="checkbox" 
                             [checked]="isSystemAccountSelected(option)"
                             (change)="toggleSystemAccountSelection(option)"
                             (click)="$event.stopPropagation()">
                      <label>{{ option.DESCRIPTION }}</label>
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>
          
}

          <!-- Local Account (by Account) - Custom Searchable Multiselect -->
          @if (formState.showLocalAccount && formState.grossIncome?.DISP_ACCT_CODE !== 'Asset Exp') {
<div class="form-group col-xs-3 col-md-3"
              >
            <label for="localAccount" class="control-label">Local Account
              @if (isLoadingLocalAccounts) {
<span class="loader-spinner"></span>
}
            </label>
            <div class="custom-searchable-multiselect" 
                 data-dropdown="localAccount"
                 [class.open]="localAccountDropdownOpen"
                 [class.disabled]="isLocalAccountDisabled()">
              <div class="dropdown-input-wrapper" 
                   (click)="!isLocalAccountDisabled() && toggleLocalAccountDropdown()">
                <input type="text" 
                       class="form-control dropdown-input" 
                       [value]="getSelectedLocalAccountsDisplay()"
                       [disabled]="isLocalAccountDisabled()"
                       readonly
                       placeholder="Select Local Account">
                <i class="fa dropdown-arrow" 
                   [ngClass]="{'fa-chevron-up': localAccountDropdownOpen, 'fa-chevron-down': !localAccountDropdownOpen}"></i>
              </div>
              @if (localAccountDropdownOpen && !isLocalAccountDisabled()) {
<div class="dropdown-menu" 
                  
                   (click)="$event.stopPropagation()">
                <div class="dropdown-search-wrapper">
                  <input type="text" 
                         class="form-control dropdown-search-input" 
                         [(ngModel)]="localAccountSearchText"
                         placeholder="Search..."
                         (click)="$event.stopPropagation()">
                  <i class="fa fa-search dropdown-search-icon"></i>
                </div>
                <div class="dropdown-actions">
                  <button type="button" class="btn btn-link btn-sm"
                          (click)="selectAllLocalAccounts(); $event.stopPropagation()">Select All</button>
                  <button type="button" class="btn btn-link btn-sm"
                          (click)="unselectAllLocalAccounts(); $event.stopPropagation()">Unselect All</button>
                </div>
                <div class="dropdown-items-wrapper">
                  @if (getFilteredLocalAccounts().length === 0) {
<div class="dropdown-no-results">No results found</div>
}
                  @for (option of getFilteredLocalAccounts(); track $index) {
<div 
                       class="dropdown-item checkbox-item"
                       (click)="toggleLocalAccountSelection(option); $event.stopPropagation()">
                    <input type="checkbox" 
                           [checked]="isLocalAccountSelected(option)"
                           (change)="toggleLocalAccountSelection(option)"
                           (click)="$event.stopPropagation()">
                    <label>{{ option.ACCT_DESC }}</label>
                  </div>
}
                </div>
              </div>
}
            </div>
          </div>
}

          <!-- Percentage (by Account) -->
          @if (formState.showPercentage) {
<div class="form-group col-xs-1 col-md-1"
              >
            <label for="percentage" class="control-label">%</label>
            <input id="percentage"
                   type="number"
                   min="1"
                   max="100"
                   step="0.01"
                   class="form-control"
                   [(ngModel)]="formState.percentage" />
          </div>
}

          <!-- Schedule M (by Schedule M) - Custom Searchable Multiselect -->
          @if (formState.showScheduleM) {
<div class="form-group col-xs-3 col-md-3"
              >
            <label for="scheduleM" class="control-label">Schedule M</label>
            <div class="custom-searchable-multiselect" 
                 data-dropdown="scheduleM"
                 [class.open]="scheduleMDropdownOpen">
              <div class="dropdown-input-wrapper" 
                   (click)="toggleScheduleMDropdown()">
                <input type="text" 
                       class="form-control dropdown-input" 
                       [value]="getSelectedScheduleMDisplay()"
                       readonly
                       placeholder="Select Schedule M">
                <i class="fa dropdown-arrow" 
                   [ngClass]="{'fa-chevron-up': scheduleMDropdownOpen, 'fa-chevron-down': !scheduleMDropdownOpen}"></i>
              </div>
              @if (scheduleMDropdownOpen) {
<div class="dropdown-menu" 
                  
                   (click)="$event.stopPropagation()">
                <div class="dropdown-search-wrapper">
                  <input type="text" 
                         class="form-control dropdown-search-input" 
                         [(ngModel)]="scheduleMSearchText"
                         placeholder="Search..."
                         (click)="$event.stopPropagation()">
                  <i class="fa fa-search dropdown-search-icon"></i>
                </div>
                <div class="dropdown-actions">
                  <button type="button" class="btn btn-link btn-sm"
                          (click)="selectAllScheduleM(); $event.stopPropagation()">Select All</button>
                  <button type="button" class="btn btn-link btn-sm"
                          (click)="unselectAllScheduleM(); $event.stopPropagation()">Unselect All</button>
                </div>
                <div class="dropdown-items-wrapper">
                  @if (getFilteredScheduleM().length === 0) {
<div class="dropdown-no-results">No results found</div>
}
                  @for (option of getFilteredScheduleM(); track $index) {
<div 
                       class="dropdown-item checkbox-item"
                       (click)="toggleScheduleMSelection(option); $event.stopPropagation()">
                    <input type="checkbox" 
                           [checked]="isScheduleMSelected(option)"
                           (change)="toggleScheduleMSelection(option)"
                           (click)="$event.stopPropagation()">
                    <label>{{ option.SCHDM_TEMPLATE_ID }} - {{ option.SCHDM_DESC }}</label>
                  </div>
}
                </div>
              </div>
}
            </div>
          </div>
}
        </div>
}
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button id="saveBtn"
                class="save-button"
                type="button"
                (click)="save()"
                [disabled]="formState.isSaveClicked">
          @if (formState.crudLoading) {
<span>
            <i class="fa fa-spinner fa-pulse"></i>
          </span>
}
          Save
        </button>
        <button id="resetBtn"
                class="reset-button"
                type="button"
                (click)="reset()">
          Reset
        </button>
        <button id="cancelBtn"
                class="cancel-button"
                type="button"
                (click)="cancel()">
          Cancel
        </button>
        <!-- Delete button (only for edit mode) -->
        @if (formState.isEditMode) {
<button
                id="deleteBtn"
                class="delete-button"
                type="button"
                (click)="delete()"
                [disabled]="formState.isDelete === 'N' || deleteLoading">
          @if (deleteLoading) {
<span>
            <i class="fa fa-spinner fa-pulse"></i>
          </span>
}
          Delete
        </button>
}
      </div>
    </div>
  </div>
}
</div>

<!-- DELETE CONFIRMATION OVERLAY -->
@if (showDeleteModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="modalConfig"
    [visible]="false"
    (confirmed)="onDeleteConfirm()"
    (cancelled)="onDeleteCancel()"
    (closed)="onDeleteCancel()">
  </gtw-confirmation-modal>
</div>
}
